import React, { Component, useEffect, useState } from 'react';
import * as d3 from "d3";

function Consent (props) {

    const updateStep = props.updateStep

    useEffect(() => {
        d3.select('.panel').transition().duration(1000).style('opacity', 1);
    })

    return (
        <div className="panel"  style={{opacity: 0}}>
            <div className="panel_content">
                <h1>Information notice</h1>
                <p className='consent_p' style={{marginTop: 0}}>I anonymously consent to participate in <strong>"NonbAInary: How Does AI Depict Gender?"</strong> conducted by Fe Simeoni.</p>
                <p className='consent_p'>I acknowledge that I have the right to withdraw my participation at any time.</p>
                <p className='consent_p'>I understand that signed consent forms, my answers of the evaluation, the audio recording and the transcripts of the workshop will be treated confidentially. The data will be only analyzed by the research team and might be published and presented to an audience. I understand that my anonymous answers will be retained by Fe Simeoni and the research group until the completion and publication of the research.</p>
                <p className='consent_p'>By clicking the following button, I confirm that I have read and understood what stated above.</p>
                <button className="button_primary" onClick={() => updateStep('.panel', 2)} style={{margin:"15px 0 0 0"}}>I give my consent</button>
            </div>
            <div className="panel_footer" style={{backgroundImage:'url("./img/PNRR_loghi.png'}}></div>
        </div>
    )
}

export default Consent;